export const JSON_URL = process.env.GATSBY_WORDPRESS_URL

// Newsletter sign-ups POST here. Zapier catch-hook routes to Mailchimp / studio inbox.
export const NEWSLETTER_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/3298056/445eznq/'


// WEBPACK FOOTER //
// ./src/constants.js